import React from 'react';
import { PurchaseFeaturesPanel, Subtitle } from './PurchaseFeaturesPanel';
import { DownloadButton } from './DownloadButton';

const staffSelectionFeatures = [
  'Hand selected by our staff',
  'Available to members only',
  'Unique and unexpected films',
  'Yours to keep forever',
  '"MetArt Film" quality',
  'Unmatched customer support',
  'Never before seen',
  'HD and UHD 4K films',
];

type Props = {
  onPurchase: React.MouseEventHandler<HTMLButtonElement>;
};

export const MovieStaffSelectionPurchasePanel = (props: Props) => {
  const headline = (
    <>
      THE WORLD&apos;S MOST BEAUTIFUL GIRLS
      <br />
      EXCLUSIVE CINEMATIC EROTICA
    </>
  );

  return (
    <PurchaseFeaturesPanel
      headline={headline}
      subtitle="What are you waiting for?"
      purchaseFeatures={staffSelectionFeatures}
    >
      <DownloadButton onClick={props.onPurchase}>Own It Now</DownloadButton>
      <Subtitle>YOU GET</Subtitle>
    </PurchaseFeaturesPanel>
  );
};
